<template>
  <div>
    <v-col cols="12">
      <v-row>
        <!-- Customer Service Performance -->
        <v-col cols="4" style="text-align: left">
          <h3>Customer Service Performance</h3>
          <hr />
          <table width="100%">
            <thead>
              <tr>
                <th></th>
                <th style="text-align: right">Seller Fulfilled</th>
                <th style="text-align: right">Fulfilled by Amazon</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="text-align: left">
                  <div>Order Defect Rate</div>
                  <div style="font-size: 13px">
                    <b>Target:</b>
                    {{
                      item.account_health.customer_service_performance
                        .order_defect_rate.target
                    }}
                  </div>
                </td>
                <td style="text-align: right">
                  <div>
                    {{
                      item.account_health.customer_service_performance
                        .order_defect_rate.seller_fulfilled.value
                    }}
                  </div>
                  <div style="font-size: 13px">
                    {{
                      item.account_health.customer_service_performance
                        .order_defect_rate.seller_fulfilled.description
                    }}
                  </div>
                </td>
                <td style="text-align: right">
                  <div>
                    {{
                      item.account_health.customer_service_performance
                        .order_defect_rate.fulfilled_by_amazon.value
                    }}
                  </div>
                  <div style="font-size: 13px">
                    {{
                      item.account_health.customer_service_performance
                        .order_defect_rate.fulfilled_by_amazon.description
                    }}
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="3"><hr /></td>
              </tr>
              <tr>
                <td colspan="3" style="text-align: left">
                  Order Defect Rate consists of three different metrics:
                </td>
              </tr>
              <tr
                v-for="(i, index) of item.account_health
                  .customer_service_performance.order_defect_rate.metrics"
                :key="index"
              >
                <td style="text-align: left">{{ i.name }}</td>
                <td style="text-align: right">
                  {{ i.seller_fulfilled.value }}
                </td>
                <td style="text-align: right">
                  {{ i.fulfilled_by_amazon.value }}
                </td>
              </tr>
            </tbody>
          </table>
        </v-col>
        <v-divider vertical></v-divider>
        <!-- Policy Compliance -->
        <v-col cols="3.9" style="text-align: left">
          <h3>Policy Compliance</h3>
          <div style="font-size: 13px">
            <b>Target: </b>{{ item.account_health.policy_compliance.target }}
          </div>
          <div>
            Account Health Rating:
            <template
              v-if="
                item.account_health.policy_compliance.account_health_rating ==
                'At Risk'
              "
            >
              <v-chip color="yellow">At Risk</v-chip>
            </template>
            <template
              v-if="
                item.account_health.policy_compliance.account_health_rating ==
                'Good'
              "
            >
              <v-chip color="green">Good</v-chip>
            </template>
            <template
              v-if="
                item.account_health.policy_compliance.account_health_rating ==
                'Critical'
              "
            >
              <v-chip color="red">Critical</v-chip>
            </template>
          </div>
          <hr />
          <table width="100%">
            <thead>
              <tr>
                <th></th>
                <th style="text-align: right">
                  Fulfilled by Seller and Amazon
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(i, index) of item.account_health.policy_compliance
                  .policy_violations"
                :key="index"
              >
                <td>{{ i.name }}</td>
                <td style="text-align: right">{{ i.value }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <b>Total:</b>
                </td>
                <td style="text-align: right">
                  <b
                    >{{
                      item.account_health.policy_compliance.product_policies
                    }}
                  </b>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <hr />
                </td>
              </tr>
              <tr>
                <td>Policy Violation Warnings:</td>
                <td style="text-align: right">
                  {{
                    item.account_health.policy_compliance
                      .policy_violation_warnings
                  }}
                </td>
              </tr>
            </tfoot>
          </table>
        </v-col>
        <v-divider vertical></v-divider>
        <!-- Shipping Performance -->
        <v-col cols="3.9" style="text-align: left">
          <h3>Shipping Performance</h3>
          <hr />
          <table width="100%">
            <thead>
              <tr>
                <td></td>
                <td style="text-align: right">Seller Fulfilled</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div>Late Shipment Rate</div>
                  <div style="font-size: 13px">
                    <b>Target: </b>
                    {{
                      item.account_health.shipping_performance
                        .late_shipment_rate.target
                    }}
                  </div>
                </td>
                <td style="text-align: right">
                  <div>
                    {{
                      item.account_health.shipping_performance
                        .late_shipment_rate.seller_fulfilled.value
                    }}
                  </div>
                  <div style="font-size: 13px">
                    {{
                      item.account_health.shipping_performance
                        .late_shipment_rate.seller_fulfilled.description
                    }}
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2"><hr /></td>
              </tr>
              <tr>
                <td>
                  <div>Pre-fulfillment Cancel Rate</div>
                  <div style="font-size: 13px">
                    <b>Target: </b>
                    {{
                      item.account_health.shipping_performance[
                        "pre-fulfillment_cancel_rate"
                      ].target
                    }}
                  </div>
                </td>
                <td style="text-align: right">
                  <div>
                    {{
                      item.account_health.shipping_performance[
                        "pre-fulfillment_cancel_rate"
                      ].seller_fulfilled.value
                    }}
                  </div>
                  <div style="font-size: 13px">
                    {{
                      item.account_health.shipping_performance[
                        "pre-fulfillment_cancel_rate"
                      ].seller_fulfilled.description
                    }}
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2"><hr /></td>
              </tr>
              <tr>
                <td>
                  <div>Valid Tracking Rate</div>
                  <div style="font-size: 13px">
                    <b>Target: </b>
                    {{
                      item.account_health.shipping_performance
                        .valid_tracking_rate.target
                    }}
                  </div>
                </td>
                <td style="text-align: right">
                  <div>
                    {{
                      item.account_health.shipping_performance
                        .valid_tracking_rate.seller_fulfilled.value
                    }}
                  </div>
                  <div style="font-size: 13px">
                    {{
                      item.account_health.shipping_performance
                        .valid_tracking_rate.seller_fulfilled.description
                    }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </v-col>
      </v-row>
    </v-col>

    <v-btn @click="cancelData" color="orange" dark small>CLOSE</v-btn>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  data: () => ({}),

  methods: {
    cancelData() {
      this.$root.$refs.accHealth.turnOffDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>